
export default {
    getPriority() {
        return window.restApi.get('v2/master/orderpriority/list?perpage=100000');
    },
    getVisitType() {
        return window.restApi.get('v2/master/patienttype/list?perpage=100000');
    },
    getWard() {
        return window.restApi.get('v2/master/ward/list?perpage=100000');
    },
    getWardV2(model) {
        return window.restApi.get('v2/master/ward/list?perpage=100000', {params: model});
    },    
    saveWard(model, config) {
        if (model.id) {
            return window.restApi.post('v2/master/ward/update', model, config);
        } else {
            return window.restApi.post('v2/master/ward/save', model, config);
        }

    },        
    getInsurer() {
        return window.restApi.get('v2/master/insurer/list?perpage=100000');
    },
    getPhysicians() {
        return window.restApi.get('v2/master/physician/list?perpage=100000');
    },
    getPhysiciansV2(model) {
        return window.restApi.get('v2/master/physician/list?perpage=100000', {params: model});
    },    
    savePhysicians(model, config) {
        if (model.id) {
            return window.restApi.post('v2/master/physician/update', model, config);
        } else {
            return window.restApi.post('v2/master/physician/save', model, config);
        }

    },    
    getTube() {
        return window.restApi.get('v2/master/tube/list?perpage=100000');
    },
    getMeasureType() {
        return window.restApi.get('v2/master/measuretype/list?perpage=100000');
    },
    getChoiceGroup() {
        return window.restApi.get('v2/master/choicegroup/list?perpage=100000');
    },
    listSupplier(model) {
        return window.restApi.get('v2/master/supplier/list', {params: model});
    },
    getSupplier(id) {
        return window.restApi.get('v2/master/supplier/get?id=' + id);
    },
    saveSupplier(model, config) {
        if (model.id) {
            return window.restApi.post('v2/master/supplier/update', model, config);
        } else {
            return window.restApi.post('v2/master/supplier/save', model, config);
        }

    },
    listProduk(model) {
        return window.restApi.get('v2/master/product/list', {params: model});
    },
    getProduk(id) {
        return window.restApi.get('v2/master/product/get?id=' + id);
    },
    saveProduk(model, config) {
        if (model.id) {
            return window.restApi.post('v2/master/product/update', model, config);
        } else {
            return window.restApi.post('v2/master/product/save', model, config);
        }
    },
    listUOM(model) {
        return window.restApi.get('v2/master/uom/list', {params: model});
    },
    getUOM(id) {
        return window.restApi.get('v2/master/uom/get?id=' + id);
    },
    saveUOM(model, config) {
        if (model.id) {
            return window.restApi.post('v2/master/uom/update', model, config);
        } else {
            return window.restApi.post('v2/master/uom/save', model, config);
        }
    },
    listProdukGroup(model) {
        return window.restApi.get('v2/master/product/group/list', {params: model});
    },
    getProdukGroup(id) {
        return window.restApi.get('v2/master/product/group/get?id=' + id);
    },
    saveProdukGroup(model, config) {
        if (model.id) {
            return window.restApi.post('v2/master/product/group/update', model, config);
        } else {
            return window.restApi.post('v2/master/product/group/save', model, config);
        }
    },
    listInstrument(model) {
        return window.restApi.get('v2/master/instrument/list', {params: model});
    },
    getInstrument(id) {
        return window.restApi.get('v2/master/instrument/get?id=' + id);
    },
    saveInstrument(model, config) {
        if (model.id) {
            return window.restApi.post('v2/master/instrument/update', model, config);
        } else {
            return window.restApi.post('v2/master/instrument/save', model, config);
        }
    },
    listReagen(model) {
        return window.restApi.get('v2/master/product/reagen/list', {params: model});
    },
    listReagenMeasure(model) {
        return window.restApi.get('v2/master/reagenmeasure/list', {params: model});
    },
    getSetting() {
        return window.restApi.get('v2/master/setting/get');
    },   
    saveSetting(model, config) {
        return window.restApi.post('v2/master/setting/save', model, config);
    },         
}
